import type { InjectionKey, Ref } from 'vue';

/** The three regions of an NxWorkspace. */
export type NxWorkspaceRegionName = 'sidebar' | 'main' | 'aside';

/**
 * What NxWorkspace hands the components inside one of its regions: which
 * region they sit in and whether the frame is in its narrow (drawer) mode.
 * Kit components use it to fill the region instead of sizing themselves —
 * NxAppSidebar drops its `100vh` and fixed width inside the sidebar region.
 */
export interface NxWorkspaceRegionContext {
  region: NxWorkspaceRegionName;
  narrow: Readonly<Ref<boolean>>;
  /**
   * The frame has a sidebar and it shows — open beside the main column, or
   * open as a drawer in the narrow mode. NxWorkspaceHeader hides a primary
   * button the sidebar already carries (`primaryInSidebar`) while it is true.
   * Optional: a context provided by hand (a test, a host) may leave it out.
   */
  sidebarVisible?: Readonly<Ref<boolean>>;
}

export const nxWorkspaceRegionKey: InjectionKey<NxWorkspaceRegionContext> =
  Symbol('NxWorkspaceRegion');
